import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top immediately when route changes
    // Use both immediate and delayed scroll to ensure it works
    window.scrollTo(0, 0);
    
    // Also try after a small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
      // Try scrolling the document element as well
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      if (document.body) {
        document.body.scrollTop = 0;
      }
    }, 0);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
};

export default ScrollToTop;

